import { useSearchParams } from 'react-router-dom';
import { SegmentedControl } from '@eo/shared';

import { ALL_PORTFOLIOS, CLIENT_GRID_PREFIX } from './constants';
import type { PortfolioPickerProps } from './types';

// Picks what the whole page reports on. The server scopes the report to it;
// the URL carries the choice so a reload or a shared link reopens it.
export function PortfolioPicker({ report }: PortfolioPickerProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const options = [
    ...report.portfolios.flatMap((p) =>
      p.ownerUserId === null ? [] : [{ value: p.ownerUserId, label: p.name }],
    ),
    { value: ALL_PORTFOLIOS, label: 'All CFOs' },
  ];

  const onChange = (value: string) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set('cfo', value);
      // A page number from one portfolio means nothing in another.
      next.delete(`${CLIENT_GRID_PREFIX}page`);
      return next;
    });
  };

  return (
    <SegmentedControl<string>
      options={options}
      // The URL moves on the click; the report only catches up when it arrives.
      value={searchParams.get('cfo') ?? report.scope.ownerUserId ?? ALL_PORTFOLIOS}
      onChange={onChange}
      ariaLabel="Portfolio"
      className="flex-wrap"
    />
  );
}
